import * as actionTypes from '../actions/actionTypes';
import { updateObject } from '../utility';

const initialState = {
    seriesTree: [],
    loading: false,
    activeSeries: null,
    activeSeriesId: 0,
    childLoading: false,
    seriesList: {},
    
};

const createSeriesList = (tree = []) => {
    return loopList(tree);
}

const loopList = (list) => {
    let elms = {};
    list.forEach((elm) => {
        elm.children = sortChilds(elm);
        let childs = loopList(elm.children);
        elms[elm.id] = elm;
        elms = { ...elms, ...childs } 
    });
    return elms;
}

const sortChilds = (elm) => {
    if(!elm.linktoepisodes) {
        return elm.children;
    }
    /*
    var itemsArray = [['Anne', 'a'], ['Bob', 'b'], ['Henry', 'b'], ['Andrew', 'd'], ['Jason', 'c'], ['Thomas', 'b']],
    sortingArr = [ 'b', 'c', 'b', 'b', 'a', 'd' ],
    map = itemsArray.reduce((m, a) => m.set(a[1], (m.get(a[1]) || []).concat([a])), new Map);
    console.log(map);
    var result = sortingArr.map(k => (map.get(k) || []).shift());
    console.log(result);
    */
    
    elm.linktoepisodes = elm.linktoepisodes.replace(/\ /g, "");
    if(!elm.linktoepisodes) {
        return elm.children;
    }
    
    const sorting = elm.linktoepisodes.split(',');
    const childs = elm.children.reduce((obj, child) => {
        obj[child.id] = child;
        return obj;
    }, {});
	const sorted = [];//
    //const sorted = sorting.map((id) => {
	sorting.forEach((id) => {
        if(childs[id]) {
            let child = childs[id];
            delete childs[id];
            sorted.push(child);
        }
    });
    
    return sorted.concat(Object.values(childs));
}

const updateTree = (state, action) => {
    let tree = state.seriesTree;
    //console.log(tree);
}

const reducer = ( state = initialState, action) => {
    switch (action.type) {
        case actionTypes.SERIES_LOAD_START:
			return updateObject(state, { loading: true });
        case actionTypes.SERIES_LOAD_SUCCESS: 
			return updateObject(state, { loading: false, seriesTree: action.data.tree || [], seriesList: createSeriesList(action.data.tree) });
        case actionTypes.SERIES_LOAD_FAIL: 
			return updateObject(state, { loading: false });
        case actionTypes.SERIES_SET_ACTIVE: 
			return updateObject(state, { activeSeries: action.series, activeSeriesId: action.series.id });
        case actionTypes.SERIES_GET_CLIPS_START:
			return updateObject(state, { childLoading: true });
        case actionTypes.SERIES_GET_CLIPS_SUCCESS:
            //console.log(action.clips);
            updateTree(state, action);
			return updateObject(state, { childLoading: false });
        case actionTypes.SERIES_DELETE_SUCCESS:
			return updateObject(state, { });
        default: 
            return state;
    }
}

export default reducer;
